import SigniteButton from '../../../ui-elements/signite-button/signiteButton';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from 'react-spinner-loader';
import { CandidatesTable } from './candidate-listing-table/candidatesTables';
import { CandidateService } from '../../../../services/candidateService';
import { prepareAssignCandidateData } from '../../../../utils/assignCandidateTableUtils';
import { Form as BSForm, FormControl, InputGroup, Modal } from 'react-bootstrap';
import { faClose, faPlusCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { QueryClient, QueryClientProvider } from 'react-query';
import { Formik } from 'formik';
import { UsersTable } from '../user-management/user-listing-table/usersTable';
import { fetchData as fetchUserData } from '../user-management/userManagementUtils';
import { UserService } from '../../../../services/userService';
import { confirm } from 'react-bootstrap-confirmation';
import { useQueryClient } from '@tanstack/react-query';
import { decodeJWT } from '../../../../services/candidateService';

const CandidateAssignment = (props) => {
  const queryClient = useQueryClient();
  const [loader, setLoader] = useState(true);
  const [candidatesLoading, setCandidatesLoading] = useState(true);
  const [usersLoading, setUsersLoading] = useState(true);
  const [username, setUsername] = useState('');
  const [firstName, setFirstName] = useState('');
  const [updatedFirstName, setUpdatedFirstName] = useState('');
  const [updatedLastName, setUpdatedLastName] = useState('');
  const [lastName, setLastName] = useState('');
  const [candiateTableData, setCandidateTableData] = useState({ columns: [], data: [] });
  const newCandidate = () => {
    window.location = '/candidate/candidate-personal-info';
  };
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  console.log(decoded)
  const [show, setShow] = useState(false);
  const [currentCandidateId, setCurrentCandidateId] = useState(null);
  const handleClose = (user) => {
    setShow(false);
  };
  const handleShow = async (candidateId) => {
    setCurrentCandidateId(candidateId);
    setShow(true);
  };

  const searchCandidate = () => {
    setUpdatedFirstName(firstName);
    setUpdatedLastName(lastName);
  };
  const initialValues = [];

  const selectUserHandler = async (user) => {
    setShow(false);
    console.log('Assigning user to candidate:', currentCandidateId, user.username);
    let result = await confirm(`Are you sure you want to assign ${currentCandidateId} to ${user.username}?`);
    if (result) {
      UserService.assignCandidate(user.username, currentCandidateId)
        .then((data) => {
          alert(`Candidate : ${currentCandidateId} assigned to ${user.username} successfully.`);
          queryClient.invalidateQueries({ queryKey: ['data'] });
        })
        .catch((error) => {
          alert(_.get(error, "response.data.message", `Error encountered during assignment process!\n${error.toString()}`));
        });

    }
  };

  const fetchData = async ({ pageIndex = 0, pageSize = 10 }) => {

    setCandidatesLoading(true);
    try {
      const decoded = decodeJWT(window.localStorage.getItem('authToken'));
      const currentUserRole = decoded?.roles;
      const currentUsername = decoded?.username;
      const isDataEntryExe = currentUserRole === 'DATA_ENTRY_EXE';

      let retData;

      if (firstName || lastName) {
        retData = isDataEntryExe
          ? await CandidateService.getAllCandidates(0, pageSize, firstName, lastName, currentUsername)
          : await CandidateService.getAllCandidates(0, pageSize, firstName, lastName);
      } else {
        retData = isDataEntryExe
          ? await CandidateService.getAllCandidates(pageIndex, pageSize, '', '', currentUsername)
          : await CandidateService.getAllCandidates(pageIndex, pageSize);
      }

      const tableData = prepareAssignCandidateData(retData, handleShow);
      setCandidatesLoading(false);
      setLoader(false);

      return {
        rows: tableData,
        pageCount: retData?.data?.pageCount ?? 1,
      };

    } catch (error) {
      console.error("fetchData error:", error);
      setCandidatesLoading(false);
      setLoader(false);

      return {
        rows: { columns: [], data: [] },
        pageCount: 0,
      };
    }
  };

  useEffect(() => {
    setUsersLoading(true);
    fetchUserData({
      pageIndex: 0,
      pageSize: 10,
      username: '',
      setLoader,
      userSelectHandler: selectUserHandler
    }).finally(() => setUsersLoading(false));
  }, []);

  useEffect(() => {
    setLoader(candidatesLoading || usersLoading);
  }, [candidatesLoading, usersLoading]);

  const [userTableData, setUserTableData] = useState({ columns: [], data: [] });
  const { userColumns, userData } = userTableData;
  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      fetchData({ pageIndex: 0, pageSize: 10 });
    }
  };
  const setSearchField = (event) => {
    switch (event.target.id) {
      case 'firstName':
        setFirstName(event.target.value);
        if (event.target.value === "" && lastName === "") {
          triggerCandidateSearch("", "");
        }
        break;
      case 'lastName':
        setLastName(event.target.value);
        if (event.target.value === "" && firstName === "") {
          triggerCandidateSearch("", "");
        }
        break;
    }
  };


  const { columns, data } = candiateTableData;

  const triggerCandidateSearch = (fname, lname) => {
    setLoader(true);
    setUpdatedFirstName(fname);
    setUpdatedLastName(lname);

    fetchData({ pageIndex: 0, pageSize: 10 });
  };

  return (
    <Container fluid>
      <Loader show={loader} type="body" stack="vertical" message="Loading Data" />

      <Formik
        enableReinitialize="true"
        initialValues={initialValues}
        onSubmit={async (data) => {
          console.log(data);
        }}
        validationSchema={null}
        isInitialValid={true}
      >
        {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
          return (
            <Modal show={show} onHide={handleClose} size="xl">
              <Modal.Header closeButton>
                <Modal.Title>Assign User to Candidate</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <BSForm>
                  <Row>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Name*</BSForm.Label>
                      <InputGroup>
                        <FormControl
                          placeholder="Search"
                          style={{ maxWidth: '80%' }}
                          name={'username'}
                          onChange={(e) => {
                            handleChange(e);
                            setUsername(e.target.value);
                          }}
                          value={values.username}
                        ></FormControl>
                        <a href="#" className="attachedButton" onClick={() => setUsername(values.username)}>
                          <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
                        </a>
                      </InputGroup>
                    </BSForm.Group>
                    <BSForm.Group as={Col}></BSForm.Group>
                    <BSForm.Group as={Col}></BSForm.Group>
                  </Row>
                  <Row style={{ overflowX: 'scroll' }}>
                    {/* <QueryClientProvider client={queryClient}> */}
                    <UsersTable
                      columns={columns}
                      fetchData={fetchUserData}
                      username={username}
                      selectable={true}
                      userSelectHandler={selectUserHandler}
                    />
                    {/* </QueryClientProvider> */}
                  </Row>
                </BSForm>
              </Modal.Body>
              <Modal.Footer>
                <SigniteButton
                  variant={'primary'}
                  className=""
                  onClick={() => {
                    handleClose(values);
                  }}
                >
                  <FontAwesomeIcon icon={faClose}></FontAwesomeIcon><span style={{ marginLeft: "5px" }}>Close</span>
                </SigniteButton>
              </Modal.Footer>
            </Modal>
          );
        }}
      </Formik>
      <Row>
        <Card className='p-0'>
          <Card.Header className="" style={{ backgroundColor: 'white' }}>
            <BSForm className="pr w-100 m-0">
              <Row className="align-items-center">
                <Col lg={5}></Col>
                <Col xs="auto">
                  <BSForm.Control
                    className="mb-2"
                    id="firstName"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setSearchField(e)}
                    spellCheck='false'
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        triggerCandidateSearch(firstName, lastName);
                      }
                    }}
                  />
                </Col>
                <Col xs="auto">
                  <BSForm.Control
                    className="mb-2"
                    id="lastName"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setSearchField(e)}
                    spellCheck='false'
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        triggerCandidateSearch(firstName, lastName);
                      }
                    }}
                  />
                </Col>
                <Col xs="auto">
                  <SigniteButton
                    variant={'primary'}
                    className="mb-2 ms-2"
                    onClick={() => triggerCandidateSearch(firstName, lastName)}
                  >
                    Search
                  </SigniteButton>
                </Col>
              </Row>
            </BSForm>

          </Card.Header>
          <Card.Body style={{ backgroundColor: 'white' }}>
            {/* <QueryClientProvider client={queryClient}> */}
            <CandidatesTable
              columns={columns}
              fetchData={fetchData}
              firstName={updatedFirstName}
              lastName={updatedLastName}
            />
            {/* </QueryClientProvider> */}
          </Card.Body>
        </Card>
      </Row>

      <Row></Row>
    </Container>
  );
};
export default CandidateAssignment;